// JOBE-0098.3: state 5 — "Did you mean" promotions + fuzzy matches.
// Decision pinned in spec: section style (not inline-ghost). Promotions
// are computed client-side from the fragment text — kebab-cased fragment
// suggested as a value for slug-shaped predicates.

import { MatchesSection } from './MatchesSection.jsx';

function kebab(s) {
  return s
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// promotionsFor: returns the list of "did you mean" candidate
// completions. Slug-shaped predicates only; the parser's vocabulary
// supplies the friendly token list.
export function promotionsFor(fragment) {
  if (!fragment) return [];
  const slug = kebab(fragment);
  if (!slug) return [];
  return [
    { friendlyToken: 'project', op: ':', values: [slug] },
    { friendlyToken: 'in', op: ':', values: [slug] },
  ];
}

export function PlainTextFallback({
  parsed,
  onSearch,
  highlightIndex,
  onHighlight,
  onPick,
  onPickPromotion,
}) {
  // Promotions only make sense for genuine fuzzy text — skip when the
  // input is all-unrecognized (retired vocab etc.). Otherwise a
  // retired-predicate string like `memberOfProject:urn:jobe:project:x`
  // generates a nonsense `project:memberofproject-urn-jobe-project-x`
  // suggestion. Per PR #696 LOW: gate on parsed.unrecognized.length === 0
  // AND require a real fuzzyFragment (don't fall back to raw input).
  const fragment = parsed?.fuzzyFragment || '';
  const hasUnrecognized = (parsed?.unrecognized || []).length > 0;
  const promotions = hasUnrecognized ? [] : promotionsFor(fragment);
  const promoCount = promotions.length;

  return (
    <div className="omni-sections">
      {promoCount > 0 && (
      <section className="omni-section omni-section-promotions" aria-label="Did you mean">
        <h4 className="omni-section-title">Did you mean</h4>
        <ul className="omni-opt-list" role="listbox">
          {promotions.map((p, i) => {
            const isHigh = i === highlightIndex;
            const token = `${p.friendlyToken}:${p.values.join(',')}`;
            return (
              <li key={token}>
                <button
                  type="button"
                  className={isHigh ? 'omni-opt omni-opt-high' : 'omni-opt'}
                  onMouseEnter={() => onHighlight && onHighlight(i)}
                  onClick={() => onPickPromotion && onPickPromotion(p)}
                  role="option"
                  aria-selected={isHigh}
                  data-promotion={token}
                >
                  <code className="omni-opt-token">{token}</code>
                </button>
              </li>
            );
          })}
        </ul>
      </section>
      )}
      <section className="omni-section omni-section-fuzzy" aria-label="Fuzzy matches">
        <h4 className="omni-section-title">Fuzzy matches</h4>
        <MatchesSection
          parsed={parsed}
          onSearch={onSearch}
          highlightIndex={highlightIndex - promoCount}
          onHighlight={(i) => onHighlight && onHighlight(i + promoCount)}
          onPick={onPick}
        />
      </section>
    </div>
  );
}
